"use client";

import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { LinkButton } from "@/components/ui/link-button";

interface ProjectsListPageHeaderProps {
  onCreate: () => void;
  headingId?: string;
}

export function ProjectsListPageHeader({
  onCreate,
  headingId,
}: ProjectsListPageHeaderProps) {
  return (
    <header className="flex items-center justify-between px-page py-5 sm:py-9 border-b border-border">
      <div className="flex flex-col gap-1 min-w-0">
        <h1
          id={headingId}
          className="text-lg font-medium text-heading leading-normal"
        >
          Projects
        </h1>
        <p className="hidden sm:block text-sm font-normal text-contrast/60 leading-normal">
          Group jobs by client or department to keep your work organized.
        </p>
      </div>
      <div className="flex items-center gap-2 sm:gap-3 shrink-0">
        <LinkButton
          href="https://docs.neuroscale.ai/core/projects"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Projects documentation (opens in new tab)"
          variant="secondary"
          size="sm"
          className="hidden sm:flex border-contrast/30 bg-transparent text-contrast/60 hover:bg-contrast/4 hover:text-contrast/60 active:bg-contrast/6"
          icon={<Icon name="IconNewspaper1" size={15} />}
        >
          Docs
        </LinkButton>
        <Button
          onClick={onCreate}
          variant="light"
          size="sm"
          icon={<Icon name="IconFolderAddLeft" size={15} />}
        >
          Create Project
        </Button>
      </div>
    </header>
  );
}
